import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Row, Col, Button, Modal, Collapse, Form, Image, InputGroup } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AutoTabProvider } from "react-auto-tab";
import { ThailandAddressTypeahead, ThailandAddressValue } from "react-thailand-address-typeahead";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import DataTableLayout from "layouts/DatatableLayout";
import DownloadExcel from "utils/DownloadExcel";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import ModalErrorCustom from "layouts/ModalErrorCustom";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllMstPrefix } from "../../redux/handlers/master/getAllMstPrefix.handler";
import { getAllMstPosition } from "../../redux/handlers/master/getAllMstPosition.handler";
import { getAllMstBank } from "../../redux/handlers/master/getAllMstBank.handler";
import { getAllMstBankAccountType } from "../../redux/handlers/master/getAllMstBankAccountType.handler";
import { getProvice } from "../../redux/handlers/master/getProvice.handler";
import { getSupProvince } from "../../redux/handlers/master/getSupProvince.handler";
import { getDistrict } from "../../redux/handlers/master/getDistrict.handler";
import { getSupProvinceSup } from "../../redux/handlers/master/getSupProvinceSup.handler";
import { getDistrictSup } from "../../redux/handlers/master/getDistrictSup.handler";
import { getAllMstBusinessCategory } from "../../redux/handlers/master/getAllMstBusinessCategory.handler";
import { getAllMstCompanyPrefix } from "../../redux/handlers/master/getAllMstCompanyPrefix.handler";
import { getAllDocument } from "../../redux/handlers/master/getAllDocument.handler";
import { base64ToBlob, generateRandomString, mapMstToOptions } from "utils/HelperFunction";
import { defaultOption } from "constants/ui/options";
import { getMemberInfo } from "../../redux/handlers/logic/getMemberInfo.handler";
import { getBusiness } from "../../redux/handlers/logic/getBusiness.handler";
import { getBusinessBank } from "../../redux/handlers/logic/getBusinessBank.handler";
import { getBusinessDoc } from "../../redux/handlers/logic/getBusinessDoc.handler";
import { getBusinessComment } from "../../redux/handlers/logic/getBusinessComment.handler";
import { clearUpdateMemberChangepassword, updateMemberChangepassword } from "../../redux/handlers/logic/updateMemberChangepassword.handler";
import { clearcreateBusinessBank, createBusinessBank } from "../../redux/handlers/logic/createBusinessBank.handler";
import { clearupdateBusinessBank, updateBusinessBank } from "../../redux/handlers/logic/updateBusinessBank.handler";
import { cleardeleteBusinessBank, deleteBusinessBank } from "../../redux/handlers/logic/deleteBusinessBank.handler";
import { clearcreateBusinessDoc, createBusinessDoc } from "../../redux/handlers/logic/createBusinessDoc.handler";
import { clearupdateBusinessDoc, updateBusinessDoc } from "../../redux/handlers/logic/updateBusinessDoc.handler";
import { cleardeleteBusinessDoc, deleteBusinessDoc } from "../../redux/handlers/logic/deleteBusinessDoc.handler";
import moment from "moment";
import "moment/locale/th";
import { getFileName, getFullUrlPath } from "utils/HandleFileFunction";
import { initialState } from "mocks/empData";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { initState } from "mocks/poData";
import { StepperLabelWizard } from "layouts/StepperLabelWizard";
import { ModalAllder } from "layouts/ModalAllder";
import { uploadInfo } from "../../redux/handlers/logic/uploadInfo.handler";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
var businessID = null;
export function InfoInex() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var accessToken = localStorage.getItem("accessToken");
    var memID = null;
    if (accessToken) {
        try {
            var base64Url = accessToken.split(".")[1];
            if (base64Url) {
                try {
                    var _payload_member, _payload_member1;
                    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
                    var payload = JSON.parse(atob(base64));
                    memID = parseInt((_payload_member = payload.member) === null || _payload_member === void 0 ? void 0 : _payload_member.mb_mem_id) || null;
                    businessID = parseInt((_payload_member1 = payload.member) === null || _payload_member1 === void 0 ? void 0 : _payload_member1.bus_business_id) || null;
                } catch (error) {
                    console.error("Failed to decode access token payload:", error);
                }
            } else {
                console.error("Invalid access token format.");
            }
        } catch (error) {
            console.error("Invalid access token:", error);
        }
    }
    var _useState = _sliced_to_array(useState(false), 2), imgData = _useState[0], setImgData = _useState[1];
    var _useState1 = _sliced_to_array(useState("1"), 2), businesstype = _useState1[0], setBusinesstype = _useState1[1];
    var _useState2 = _sliced_to_array(useState("1"), 2), businesscategoryid = _useState2[0], setBusinesscategoryid = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), formdisabled = _useState3[0], setFormdisabled = _useState3[1];
    var getAllMstPrefixReducer = useAppSelector(function(state) {
        return state.getAllMstPrefixReducer;
    });
    var getProviceReducer = useAppSelector(function(state) {
        return state.getProviceReducer;
    });
    var getSupProvinceReducer = useAppSelector(function(state) {
        return state.getSupProvinceReducer;
    });
    var getSupProvinceSupReducer = useAppSelector(function(state) {
        return state.getSupProvinceSupReducer;
    });
    var getDistrictReducer = useAppSelector(function(state) {
        return state.getDistrictReducer;
    });
    var getDistrictSupReducer = useAppSelector(function(state) {
        return state.getDistrictSupReducer;
    });
    var getMemberInfoReducer = useAppSelector(function(state) {
        return state.getMemberInfoReducer;
    });
    var getBusinessReducer = useAppSelector(function(state) {
        return state.getBusinessReducer;
    });
    var getAllMstBankReducer = useAppSelector(function(state) {
        return state.getAllMstBankReducer;
    });
    var getAllMstBankAccountTypeReducer = useAppSelector(function(state) {
        return state.getAllMstBankAccountTypeReducer;
    });
    var getAllMstBusinessCategoryReducer = useAppSelector(function(state) {
        return state.getAllMstBusinessCategoryReducer;
    });
    var getAllMstCompanyPrefixReducer = useAppSelector(function(state) {
        return state.getAllMstCompanyPrefixReducer;
    });
    var getBusinessBankReducer = useAppSelector(function(state) {
        return state.getBusinessBankReducer;
    });
    var getBusinessDocReducer = useAppSelector(function(state) {
        return state.getBusinessDocReducer;
    });
    var getBusinessCommentReducer = useAppSelector(function(state) {
        return state.getBusinessCommentReducer;
    });
    var getAllDocumentReducer = useAppSelector(function(state) {
        return state.getAllDocumentReducer;
    });
    var _useState4 = _sliced_to_array(useState({}), 2), formDataMember = _useState4[0], setFormDataMember = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        token: btoa(JSON.stringify({
            timestamp: Date.now(),
            random: Math.random()
        })),
        bus_business_memid: "",
        bus_business_businesstype: "",
        bus_business_vendorcode: "",
        bus_business_categoryid: 1,
        bus_business_comprefixid: 1,
        bus_business_comprefixname: "",
        bus_business_suffixname: "",
        bus_business_vatcode: "",
        bus_business_branchname: "",
        bus_business_shortname: "",
        bus_business_name: "",
        bus_business_prefixid: "",
        bus_business_taxid: "",
        bus_business_fname: "",
        bus_business_lname: "",
        bus_business_phone: "",
        bus_business_email: "",
        bus_business_address: "",
        bus_business_provinceid: 0,
        bus_business_subprovinceid: 0,
        bus_business_districtid: 0,
        bus_business_zipcodeid: "",
        bus_business_docaddress: "",
        bus_business_docprovinceid: 0,
        bus_business_docsubprovinceid: 0,
        bus_business_docdistrictid: 0,
        bus_business_doczipcodeid: "",
        bus_business_docphone: "",
        bus_business_doctel: "",
        bus_business_docemail: "",
        bus_business_mainfname: "",
        bus_business_mainlname: "",
        bus_business_mainnname: "",
        bus_business_mainposition: "",
        bus_business_mainphone: "",
        bus_business_maintel: "",
        bus_business_mainemail: "",
        bus_business_subfname: "",
        bus_business_sublname: "",
        bus_business_subnname: "",
        bus_business_subposition: "",
        bus_business_subphone: "",
        bus_business_subtel: "",
        bus_business_subemail: "",
        bus_business_soemail: "",
        bus_business_sowebsite: "",
        bus_business_sofb: "",
        bus_business_solineoa: "",
        bus_business_soig: "",
        bus_business_sotiktok: "",
        bus_business_soshopee: "",
        bus_business_solazada: "",
        bus_business_urlmap: "",
        bus_business_profile: ""
    }), 2), formData = _useState5[0], setFormData = _useState5[1];
    var loadAllMsts = function() {
        dispatch(getAllMstPrefix());
        dispatch(getAllMstBank());
        dispatch(getAllMstBankAccountType());
        dispatch(getProvice());
        dispatch(getSupProvince(formData.bus_business_provinceid));
        dispatch(getSupProvinceSup(formData.bus_business_docprovinceid));
        dispatch(getDistrict(formData.bus_business_subprovinceid));
        dispatch(getDistrictSup(formData.bus_business_docsubprovinceid));
        dispatch(getAllMstBusinessCategory());
        dispatch(getAllMstCompanyPrefix());
        dispatch(getAllDocument());
    };
    var _useState6 = _sliced_to_array(useState([]), 2), optionsMstPrefix = _useState6[0], setOptionsMstPrefix = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), optionsProvice = _useState7[0], setOptionsProvice = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), optionsSupProvince = _useState8[0], setOptionsSupProvince = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), optionsSupProvinceSup = _useState9[0], setOptionsSupProvinceSup = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), optionsDistrict = _useState10[0], setOptionsDistrict = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), optionsDistrictSup = _useState11[0], setOptionsDistrictSup = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), optionsMstBank = _useState12[0], setOptionsMstBank = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), optionsMstBankAccountType = _useState13[0], setOptionsMstBankAccountType = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), optionsMstBusinessCategory = _useState14[0], setOptionsMstBusinessCategory = _useState14[1];
    var _useState15 = _sliced_to_array(useState([]), 2), optionsMstCompanyPrefix = _useState15[0], setOptionsMstCompanyPrefix = _useState15[1];
    var _useState16 = _sliced_to_array(useState([]), 2), optionsMstDoc = _useState16[0], setOptionsMstDoc = _useState16[1];
    var _useState17 = _sliced_to_array(useState(1), 2), stepIndex = _useState17[0], setStepIndex = _useState17[1];
    useEffect(function() {
        loadAllMsts();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstPrefixReducer.isFetching || getAllMstBankReducer.isFetching || getAllMstBankAccountTypeReducer.isFetching || getAllMstBusinessCategoryReducer.isFetching || getAllMstCompanyPrefixReducer.isFetching || getAllDocumentReducer.isFetching);
        if (getAllMstPrefixReducer.data) {
            var options = mapMstToOptions(getAllMstPrefixReducer.data.data);
            setOptionsMstPrefix(_to_consumable_array(options));
        }
        if (getAllMstBankReducer.data) {
            var options1 = mapMstToOptions(getAllMstBankReducer.data.data);
            setOptionsMstBank(_to_consumable_array(options1));
        }
        if (getAllMstBankAccountTypeReducer.data) {
            var options2 = mapMstToOptions(getAllMstBankAccountTypeReducer.data.data);
            setOptionsMstBankAccountType(_to_consumable_array(options2));
        }
        if (getAllMstBusinessCategoryReducer.data) {
            var options3 = mapMstToOptions(getAllMstBusinessCategoryReducer.data.data);
            setOptionsMstBusinessCategory(_to_consumable_array(options3));
        }
        if (getAllMstCompanyPrefixReducer.data) {
            var options4 = mapMstToOptions(getAllMstCompanyPrefixReducer.data.data);
            setOptionsMstCompanyPrefix(_to_consumable_array(options4));
        }
        if (getAllDocumentReducer.data) {
            // const options = mapMstToOptions(getAllDocumentReducer.data.data);
            // setOptionsMstDoc([...options]);
            var getOptions = getAllDocumentReducer.data.data;
            var options5 = getOptions.map(function(item) {
                return {
                    label: item.bus_documents_name,
                    value: item.bus_documents_id
                };
            });
            setOptionsMstDoc(_to_consumable_array(options5));
        }
    }, [
        getAllMstPrefixReducer,
        getAllMstBankReducer,
        getAllMstBankAccountTypeReducer,
        getAllMstBusinessCategoryReducer,
        getAllMstCompanyPrefixReducer,
        getAllDocumentReducer
    ]);
    useEffect(function() {
        setIsLoading(getProviceReducer.isFetching);
        if (getProviceReducer.data) {
            var getOptions = getProviceReducer.data.data;
            var options = getOptions.map(function(item) {
                return {
                    label: JSON.parse(item.province_name).th,
                    value: item.province_provinceid
                };
            });
            setOptionsProvice(_to_consumable_array(options));
        }
    }, [
        getProviceReducer
    ]);
    useEffect(function() {
        setIsLoading(getSupProvinceReducer.isFetching);
        if (getSupProvinceReducer.data) {
            var getOptions = getSupProvinceReducer.data.data;
            var options = getOptions.map(function(item) {
                return {
                    label: JSON.parse(item.district_name).th,
                    value: item.district_districtid
                };
            });
            setOptionsSupProvince(_to_consumable_array(options));
        }
    }, [
        getSupProvinceReducer
    ]);
    useEffect(function() {
        setIsLoading(getSupProvinceSupReducer.isFetching);
        if (getSupProvinceSupReducer.data) {
            var getOptions = getSupProvinceSupReducer.data.data;
            var options = getOptions.map(function(item) {
                return {
                    label: JSON.parse(item.district_name).th,
                    value: item.district_districtid
                };
            });
            setOptionsSupProvinceSup(_to_consumable_array(options));
        }
    }, [
        getSupProvinceSupReducer
    ]);
    useEffect(function() {
        setIsLoading(getDistrictReducer.isFetching);
        if (getDistrictReducer.data) {
            var getOptions = getDistrictReducer.data.data;
            var options = getOptions.map(function(item) {
                return {
                    label: JSON.parse(item.subdistrict_name).th,
                    value: item.subdistrict_subdistrictid,
                    postcode: item.subdistrict_postcode
                };
            });
            setOptionsDistrict(_to_consumable_array(options));
        }
    }, [
        getDistrictReducer
    ]);
    useEffect(function() {
        setIsLoading(getDistrictSupReducer.isFetching);
        if (getDistrictSupReducer.data) {
            var getOptions = getDistrictSupReducer.data.data;
            var options = getOptions.map(function(item) {
                return {
                    label: JSON.parse(item.subdistrict_name).th,
                    value: item.subdistrict_subdistrictid,
                    postcode: item.subdistrict_postcode
                };
            });
            setOptionsDistrictSup(_to_consumable_array(options));
        }
    }, [
        getDistrictSupReducer
    ]);
    useEffect(function() {
        setIsLoading(getMemberInfoReducer.isFetching);
        if (getMemberInfoReducer.data) {
            setFormDataMember(function(prev) {
                return _object_spread_props(_object_spread({}, getMemberInfoReducer.data.data), {
                    mb_mem_passdate: formDataMember.mb_mem_passdate != null ? moment(formDataMember.mb_mem_passdate).format("DD-MM-YYYY HH:mm:ss") : ""
                });
            });
        }
    }, [
        getMemberInfoReducer
    ]);
    useEffect(function() {
        setIsLoading(getBusinessReducer.isFetching);
        if (getBusinessReducer.data) {
            var _getBusinessReducer_data_data, _getBusinessReducer_data, _getBusinessReducer_data_data1, _getBusinessReducer_data1, _getBusinessReducer_data_data2, _getBusinessReducer_data2, _getBusinessReducer_data_data3, _getBusinessReducer_data3;
            console.log("getBusinessReducer.data :", getBusinessReducer.data.data);
            setFormData(function(prev) {
                return _object_spread({}, prev, getBusinessReducer.data.data);
            });
            setBusinesstype(getBusinessReducer.data.data.bus_business_businesstype);
            dispatch(getSupProvince((getBusinessReducer === null || getBusinessReducer === void 0 ? void 0 : (_getBusinessReducer_data = getBusinessReducer.data) === null || _getBusinessReducer_data === void 0 ? void 0 : (_getBusinessReducer_data_data = _getBusinessReducer_data.data) === null || _getBusinessReducer_data_data === void 0 ? void 0 : _getBusinessReducer_data_data.bus_business_provinceid) || 0));
            dispatch(getDistrict((getBusinessReducer === null || getBusinessReducer === void 0 ? void 0 : (_getBusinessReducer_data1 = getBusinessReducer.data) === null || _getBusinessReducer_data1 === void 0 ? void 0 : (_getBusinessReducer_data_data1 = _getBusinessReducer_data1.data) === null || _getBusinessReducer_data_data1 === void 0 ? void 0 : _getBusinessReducer_data_data1.bus_business_subprovinceid) || 0));
            dispatch(getSupProvinceSup((getBusinessReducer === null || getBusinessReducer === void 0 ? void 0 : (_getBusinessReducer_data2 = getBusinessReducer.data) === null || _getBusinessReducer_data2 === void 0 ? void 0 : (_getBusinessReducer_data_data2 = _getBusinessReducer_data2.data) === null || _getBusinessReducer_data_data2 === void 0 ? void 0 : _getBusinessReducer_data_data2.bus_business_docprovinceid) || 0));
            dispatch(getDistrictSup((getBusinessReducer === null || getBusinessReducer === void 0 ? void 0 : (_getBusinessReducer_data3 = getBusinessReducer.data) === null || _getBusinessReducer_data3 === void 0 ? void 0 : (_getBusinessReducer_data_data3 = _getBusinessReducer_data3.data) === null || _getBusinessReducer_data_data3 === void 0 ? void 0 : _getBusinessReducer_data_data3.bus_business_docsubprovinceid) || 0));
            setImgData(getBusinessReducer.data.data.bus_business_profile ? getBusinessReducer.data.data.bus_business_profile : "");
        }
    }, [
        getBusinessReducer
    ]);
    useEffect(function() {
        setIsLoading(getBusinessBankReducer.isFetching);
        if (getBusinessBankReducer.data) {
            var dataBB = [];
            getBusinessBankReducer.data.data.map(function(ele) {
                // const aa = ele.bus_bank_file == "" ? ele.bus_bank_file : null;
                dataBB.push(_object_spread_props(_object_spread({}, ele), {
                    id: nanoid(),
                    bus_bank_doctype: 1
                }));
            });
            setBank(dataBB);
        }
    }, [
        getBusinessBankReducer
    ]);
    useEffect(function() {
        setIsLoading(getBusinessDocReducer.isFetching);
        if (getBusinessDocReducer.data) {
            var dataDD = [];
            getBusinessDocReducer.data.data.map(function(ele, i) {
                dataDD.push(_object_spread_props(_object_spread({}, ele), {
                    id: nanoid()
                }));
            });
            if (getBusinessDocReducer.data.data.length > 0) {
                setDocuments(dataDD);
            }
        }
    }, [
        getBusinessDocReducer
    ]);
    useEffect(function() {
        setIsLoading(getBusinessCommentReducer.isFetching);
        if (getBusinessCommentReducer.data) {
            var dataComment = [];
            getBusinessCommentReducer.data.data.map(function(ele, i) {
                dataComment.push(_object_spread_props(_object_spread({}, ele), {
                    id: nanoid()
                }));
            });
            if (getBusinessCommentReducer.data.data.length > 0) {
                setComment(dataComment);
            }
        }
    }, [
        getBusinessCommentReducer
    ]);
    useEffect(function() {
        if (memID != null && memID != 0 && memID != undefined) {
            dispatch(getBusiness(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getBusinessBank(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getBusinessDoc(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getBusinessComment(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getMemberInfo(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, []);
    var _useState18 = _sliced_to_array(useState([]), 2), bank = _useState18[0], setBank = _useState18[1];
    var _useState19 = _sliced_to_array(useState({}), 2), dataBank = _useState19[0], setDataBank = _useState19[1];
    var _useState20 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1100,
        height: 250,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalBank = _useState20[0], setModalBank = _useState20[1];
    var _useState21 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 300,
        height: 220,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalDelBank = _useState21[0], setModalDelBank = _useState21[1];
    var _useState22 = _sliced_to_array(useState([]), 2), documents = _useState22[0], setDocuments = _useState22[1];
    var _useState23 = _sliced_to_array(useState({}), 2), dataDoc = _useState23[0], setDataDoc = _useState23[1];
    var _useState24 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 500,
        height: 200,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalDoc = _useState24[0], setModalDoc = _useState24[1];
    var _useState25 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 300,
        height: 220,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalDelDoc = _useState25[0], setModalDelDoc = _useState25[1];
    var _useState26 = _sliced_to_array(useState([]), 2), comment = _useState26[0], setComment = _useState26[1];
    var optionsDoc = [
        {
            value: 1,
            label: "หน้าสมุดบัญชีธนาคาร"
        }
    ];
    // const optionsMstDoc = [
    //   { value: 1, label: "หนังสือรับรองบริษัท" }, //t2
    //   { value: 2, label: "ภพ.20" }, //t2
    //   { value: 3, label: "เอกสารของกรรมการผู้มีอำนาจลงนาม" }, //t2
    //   { value: 4, label: "เอกสารของผู้ดำเนินการ ( บัตรประชาชน )" },
    //   { value: 5, label: "เอกสารของผู้ดำเนินการ ( ทะเบียนบ้าน )" },
    //   { value: 6, label: "อื่นๆ" }, //t2 // t1
    // ];
    // Module Change Password
    var updateMemberChangepasswordReducer = useAppSelector(function(state) {
        return state.updateMemberChangepasswordReducer;
    });
    var _useState27 = _sliced_to_array(useState("password"), 2), inputtype = _useState27[0], setInputtype = _useState27[1];
    var _useState28 = _sliced_to_array(useState({
        passwordold: "",
        password: "",
        confrimpassword: ""
    }), 2), formDataChangePassword = _useState28[0], setFormDataChangePassword = _useState28[1];
    var _useState29 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState29[0], setModalsuccess = _useState29[1];
    var _useState30 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalerror = _useState30[0], setModalerror = _useState30[1];
    var _useState31 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 350,
        height: 370,
        pin: false,
        mode: "normal",
        modalname: "changepassword"
    }), 2), modalChangePassword = _useState31[0], setModalChangePassword = _useState31[1];
    var handleClickChangePassword = function() {
        if (!formDataChangePassword.passwordold || formDataChangePassword.passwordold.trim() == "" || formDataChangePassword.passwordold.trim() == null || formDataChangePassword.passwordold.trim() == undefined) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกรหัสผ่านเก่า"
            }));
            return;
        }
        if (!formDataChangePassword.password || formDataChangePassword.password.trim() == "" || formDataChangePassword.password.trim() == null || formDataChangePassword.password.trim() == undefined) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกรหัสผ่านใหม่"
            }));
            return;
        }
        if (!formDataChangePassword.confrimpassword || formDataChangePassword.confrimpassword.trim() == "" || formDataChangePassword.confrimpassword.trim() == null || formDataChangePassword.confrimpassword.trim() == undefined) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกยืนยันรหัสผ่านใหม่"
            }));
            return;
        }
        if (formDataChangePassword.password !== formDataChangePassword.confrimpassword) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "รหัสผ่านใหม่ไม่ตรงกัน"
            }));
            return;
        }
        setIsLoading(true);
        var payload = {
            memid: memID,
            passwordold: formDataChangePassword.passwordold,
            password: formDataChangePassword.password,
            confrimpassword: formDataChangePassword.confrimpassword
        };
        dispatch(updateMemberChangepassword(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var handleCloseChangePassword = function() {
        setFormDataChangePassword({
            passwordold: "",
            password: "",
            confrimpassword: ""
        });
        setModalChangePassword(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
    };
    useEffect(function() {
        setIsLoading(updateMemberChangepasswordReducer.isFetching);
        if (updateMemberChangepasswordReducer.data && !updateMemberChangepasswordReducer.isError) {
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "รีเซ็ตรหัสผ่านสำเร็จ",
                    direction: ""
                });
            });
            handleCloseChangePassword();
            dispatch(clearUpdateMemberChangepassword());
        }
    }, [
        updateMemberChangepasswordReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "document-page",
        children: [
            (formData === null || formData === void 0 ? void 0 : formData.bus_business_status) > 1 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "".concat(stepIndex === 1 ? "contained" : "text", " "),
                                type: "button",
                                onClick: function() {
                                    setStepIndex(1);
                                },
                                className: "".concat(stepIndex === 1 ? "btn-danger" : "", " mr-3"),
                                children: "ข้อมูลธุรกิจ"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "".concat(stepIndex === 2 ? "contained" : "text", " "),
                                type: "button",
                                onClick: function() {
                                    setStepIndex(2);
                                },
                                className: "".concat(stepIndex === 2 ? "btn-danger" : "", " mr-3"),
                                children: "ข้อมูลผู้ติดต่อ"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "".concat(stepIndex === 3 ? "contained" : "text", " "),
                                type: "button",
                                onClick: function() {
                                    setStepIndex(3);
                                },
                                className: "".concat(stepIndex === 3 ? "btn-danger" : "", " mr-3"),
                                children: "ข้อมูล Social"
                            }),
                            (formData === null || formData === void 0 ? void 0 : formData.bus_business_status) == 3 && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        variant: "".concat(stepIndex === 4 ? "contained" : "text", " "),
                                        type: "button",
                                        onClick: function() {
                                            setStepIndex(4);
                                        },
                                        className: "".concat(stepIndex === 4 ? "btn-danger" : "", " mr-3"),
                                        children: "ข้อมูลธนาคาร"
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        variant: "".concat(stepIndex === 5 ? "contained" : "text", " "),
                                        type: "button",
                                        onClick: function() {
                                            setStepIndex(5);
                                        },
                                        className: "".concat(stepIndex === 5 ? "btn-danger" : "", " mr-3"),
                                        children: "เอกสาร"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "".concat(stepIndex === 6 ? "contained" : "text", " "),
                                type: "button",
                                onClick: function() {
                                    setStepIndex(6);
                                },
                                className: "".concat(stepIndex === 6 ? "btn-danger" : "", " mr-3"),
                                children: "ข้อมูลบัญชี"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card pagezoom card-st-3 mb-4",
                        style: {
                            minWidth: "1000px"
                        },
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card-body px-xl-3",
                            children: /*#__PURE__*/ _jsx(Formik, {
                                enableReinitialize: true,
                                initialValues: formData,
                                validateOnMount: true,
                                onSubmit: function(values) {
                                // console.log(values);
                                },
                                children: function(param) {
                                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid;
                                    return /*#__PURE__*/ _jsx(Form, {
                                        noValidate: true,
                                        oValidate: true,
                                        onSubmit: function(e) {
                                            e.preventDefault();
                                        //   handleSubmit();
                                        },
                                        children: /*#__PURE__*/ _jsxs("fieldset", {
                                            disabled: formdisabled,
                                            children: [
                                                stepIndex == 1 && /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold tc-5 mb-2",
                                                            children: "ข้อมูลกิจการ"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "mb-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 12,
                                                                    lg: 10,
                                                                    xl: 10,
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex align-items-center mb-4 mt-3 ",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "bx-upload mr-3",
                                                                                children: imgData ? /*#__PURE__*/ _jsx("img", {
                                                                                    src: imgData
                                                                                }) : /*#__PURE__*/ _jsx("div", {
                                                                                    className: "preimg"
                                                                                })
                                                                            }),
                                                                            (formData === null || formData === void 0 ? void 0 : formData.bus_business_status) == 1 ? /*#__PURE__*/ _jsx("div", {
                                                                                className: "px-2 py-1 text-center",
                                                                                style: {
                                                                                    color: "#6D788D)",
                                                                                    backgroundColor: "rgba(244, 244, 244, 1)",
                                                                                    borderRadius: "20px",
                                                                                    width: "150px"
                                                                                },
                                                                                children: "แบบร่าง"
                                                                            }) : (formData === null || formData === void 0 ? void 0 : formData.bus_business_status) == 2 ? /*#__PURE__*/ _jsx("div", {
                                                                                className: "px-2 py-1 text-center",
                                                                                style: {
                                                                                    color: "#FDB428",
                                                                                    backgroundColor: "#FFF6E5",
                                                                                    borderRadius: "20px",
                                                                                    width: "150px"
                                                                                },
                                                                                children: "รอตรวจสอบ"
                                                                            }) : (formData === null || formData === void 0 ? void 0 : formData.bus_business_status) == 3 ? /*#__PURE__*/ _jsxs("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "px-2 py-1 text-center mb-1",
                                                                                        style: {
                                                                                            color: "#FFFFFF",
                                                                                            backgroundColor: "#10B02A",
                                                                                            borderRadius: "20px",
                                                                                            width: "150px"
                                                                                        },
                                                                                        children: "อนุมัติ"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Alert, {
                                                                                        severity: "error",
                                                                                        children: "หากต้องการเปลี่ยนแปลงข้อมูลกรุณาติดต่อ Admin"
                                                                                    })
                                                                                ]
                                                                            }) : (formData === null || formData === void 0 ? void 0 : formData.bus_business_status) == 4 ? /*#__PURE__*/ _jsx(_Fragment, {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "px-2 py-1 text-center",
                                                                                    style: {
                                                                                        color: "#FDB428",
                                                                                        backgroundColor: "#FFF6E5",
                                                                                        borderRadius: "20px",
                                                                                        width: "150px"
                                                                                    },
                                                                                    children: "กรุณาแก้ไขข้อมูล"
                                                                                })
                                                                            }) : (formData === null || formData === void 0 ? void 0 : formData.bus_business_status) == 5 ? /*#__PURE__*/ _jsx("div", {
                                                                                className: "px-2 py-1 text-center",
                                                                                style: {
                                                                                    color: "#F95057",
                                                                                    backgroundColor: "#FFE3E3",
                                                                                    borderRadius: "20px",
                                                                                    width: "150px"
                                                                                },
                                                                                children: "ไม่อนุมัติ"
                                                                            }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 12,
                                                                    lg: 2,
                                                                    xl: 2,
                                                                    children: (formData === null || formData === void 0 ? void 0 : formData.bus_business_status) == 4 && /*#__PURE__*/ _jsx("div", {
                                                                        className: "d-flex justify-content-end",
                                                                        children: /*#__PURE__*/ _jsx(Button, {
                                                                            type: "button",
                                                                            onClick: function(e) {
                                                                                navigate("/info/create");
                                                                            },
                                                                            className: "btn-warning me-3 btn btn-lg ms-auto",
                                                                            children: "แก้ไข"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center mb-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "p-radio-1",
                                                                                label: "บุคคลธรรมดา",
                                                                                checked: businesstype == 1 ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                name: "bus_business_businesstype",
                                                                                onChange: function() {
                                                                                    setBusinesstype(1);
                                                                                },
                                                                                disabled: true
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Check // prettier-ignore
                                                                            , {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "p-radio-2",
                                                                                label: "นิติบุคคล",
                                                                                checked: businesstype == 2 ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                name: "bus_business_businesstype",
                                                                                onChange: function() {
                                                                                    setBusinesstype(2);
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    }, "p-radio")
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 2,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "VENDOR CODE"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_vendorcode",
                                                                                placeholder: "VENDOR CODE",
                                                                                value: values.bus_business_vendorcode,
                                                                                onChange: function() {},
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center mb-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 7,
                                                                    md: 7,
                                                                    lg: 5,
                                                                    xl: 2,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เลขที่ประจำตัวผู้เสียภาษี"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_taxid",
                                                                                placeholder: "เลขที่ประจำตัวผู้เสียภาษี",
                                                                                value: values.bus_business_taxid,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_taxid: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                businesstype == 2 && /*#__PURE__*/ _jsx(_Fragment, {
                                                                    children: /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 12,
                                                                        md: 6,
                                                                        lg: 4,
                                                                        xl: 3,
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            children: optionsMstBusinessCategory.map(function(c, idx) {
                                                                                return /*#__PURE__*/ _jsx(Form.Check, {
                                                                                    inline: true,
                                                                                    type: "radio",
                                                                                    id: "p-radiocategory-".concat(c.value),
                                                                                    label: c.label,
                                                                                    checked: businesscategoryid == 1 ? true : false,
                                                                                    className: "form-check-st-2 tc-7 mt-0",
                                                                                    name: "bus_business_categoryid",
                                                                                    onChange: function() {
                                                                                        setBusinesscategoryid(c.value);
                                                                                    },
                                                                                    disabled: true
                                                                                });
                                                                            })
                                                                        }, "p-radio")
                                                                    })
                                                                }),
                                                                businesstype == 1 && /*#__PURE__*/ _jsxs(_Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Col, {
                                                                            xs: 12,
                                                                            md: 6,
                                                                            lg: 4,
                                                                            xl: 2,
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "คำนำหน้าชื่อ"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "bus_business_prefixid",
                                                                                        className: "w-100 select-st-1",
                                                                                        placeholder: "เลือกคำนำหน้าชื่อ",
                                                                                        options: optionsMstPrefix,
                                                                                        value: optionsMstPrefix.filter(function(item) {
                                                                                            return item.value === values.bus_business_prefixid;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                bus_business_prefixid: e.value
                                                                                            })); // Update formData state
                                                                                        },
                                                                                        isDisabled: true
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Col, {
                                                                            xs: 12,
                                                                            md: 6,
                                                                            lg: 4,
                                                                            xl: 2,
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ชื่อ"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "bus_business_fname",
                                                                                        placeholder: "กรอกชื่อ",
                                                                                        value: values.bus_business_fname,
                                                                                        onChange: function(e) {
                                                                                            handleChange(e); // Update Formik's state
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                bus_business_fname: e.target.value
                                                                                            })); // Update formData state
                                                                                        },
                                                                                        readOnly: true,
                                                                                        disabled: true
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Col, {
                                                                            xs: 12,
                                                                            md: 6,
                                                                            lg: 4,
                                                                            xl: 2,
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "นามสกุล"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "bus_business_lname",
                                                                                        placeholder: "กรอกนามสกุล",
                                                                                        value: values.bus_business_lname,
                                                                                        onChange: function(e) {
                                                                                            handleChange(e); // Update Formik's state
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                bus_business_lname: e.target.value
                                                                                            })); // Update formData state
                                                                                        },
                                                                                        readOnly: true,
                                                                                        disabled: true
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        businesstype == 2 && /*#__PURE__*/ _jsx(_Fragment, {
                                                            children: /*#__PURE__*/ _jsxs(Row, {
                                                                className: "align-items-center mb-3",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 12,
                                                                        md: 6,
                                                                        lg: 4,
                                                                        xl: 2,
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ประเภท"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                    as: "select",
                                                                                    className: "w-100 select-st-1",
                                                                                    placeholder: "กรอก ประเภท",
                                                                                    name: "bus_business_comprefixid",
                                                                                    options: optionsMstCompanyPrefix,
                                                                                    value: optionsMstCompanyPrefix.filter(function(item) {
                                                                                        return item.value === values.bus_business_comprefixid;
                                                                                    }),
                                                                                    onChange: function(e) {
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            bus_business_comprefixid: e.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    isDisabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 12,
                                                                        md: 6,
                                                                        lg: 4,
                                                                        xl: 1,
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "คำนำหน้า"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "bus_business_comprefixname",
                                                                                    placeholder: "กรอกคำนำหน้า",
                                                                                    value: values.bus_business_comprefixname,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            bus_business_comprefixname: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 12,
                                                                        md: 6,
                                                                        lg: 4,
                                                                        xl: 2,
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ชื่อธุรกิจ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "bus_business_name",
                                                                                    placeholder: "กรอกชื่อธุรกิจ",
                                                                                    value: values.bus_business_name,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            bus_business_name: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 12,
                                                                        md: 6,
                                                                        lg: 4,
                                                                        xl: 2,
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "คำลงท้าย"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "bus_business_suffixname",
                                                                                    placeholder: "กรอกคำลงท้าย",
                                                                                    value: values.bus_business_suffixname,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            bus_business_suffixname: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 12,
                                                                        md: 6,
                                                                        lg: 4,
                                                                        xl: 2,
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "รหัสสาขา (VAT CODE)"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "bus_business_vatcode",
                                                                                    placeholder: "กรอกรหัสสาขา (VAT CODE)",
                                                                                    value: values.bus_business_vatcode,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            bus_business_vatcode: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 12,
                                                                        md: 6,
                                                                        lg: 4,
                                                                        xl: 2,
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ชื่อสาขา"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "bus_business_branchname",
                                                                                    placeholder: "กรอกชื่อสาขา",
                                                                                    value: values.bus_business_branchname,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            bus_business_branchname: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Col, {
                                                                        xs: 12,
                                                                        md: 6,
                                                                        lg: 4,
                                                                        xl: 1,
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ชื่อย่อ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "bus_business_shortname",
                                                                                    placeholder: "กรอกชื่อย่อ",
                                                                                    value: values.bus_business_shortname,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            bus_business_shortname: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold tc-5 mb-3",
                                                            children: "ที่อยู่ธุรกิจ"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center mb-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 12,
                                                                    lg: 8,
                                                                    xl: 4,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ที่อยู่ธุรกิจ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "company_address",
                                                                                placeholder: "กรอกที่อยู่",
                                                                                value: values.bus_business_address,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_address: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 2,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "จังหวัด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                name: "bus_business_provinceid",
                                                                                className: "w-100 select-st-1",
                                                                                placeholder: "เลือกจังหวัด",
                                                                                options: optionsProvice,
                                                                                value: optionsProvice.filter(function(item) {
                                                                                    return item.value === values.bus_business_provinceid;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    dispatch(getSupProvince(e.value));
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_provinceid: e.value,
                                                                                        bus_business_subprovinceid: 0,
                                                                                        bus_business_districtid: 0
                                                                                    })); // Update formData state
                                                                                },
                                                                                isDisabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 2,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "อำเภอ/เขต"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                className: "w-100 select-st-1",
                                                                                placeholder: "เลือกอำเภอ/เขต",
                                                                                name: "bus_business_subprovinceid",
                                                                                options: optionsSupProvince,
                                                                                value: optionsSupProvince.filter(function(item) {
                                                                                    return item.value === values.bus_business_subprovinceid;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    dispatch(getDistrict(e.value));
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_subprovinceid: e.value,
                                                                                        bus_business_districtid: 0
                                                                                    })); // Update formData state
                                                                                },
                                                                                isDisabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 2,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "แขวง/ตำบล"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                className: "w-100 select-st-1",
                                                                                placeholder: "เลือกแขวง/ตำบล",
                                                                                name: "bus_business_districtid",
                                                                                options: optionsDistrict,
                                                                                value: optionsDistrict.filter(function(item) {
                                                                                    return item.value === values.bus_business_districtid;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_districtid: e.value,
                                                                                        bus_business_zipcodeid: optionsDistrict.find(function(item) {
                                                                                            return item.value === e.value;
                                                                                        }).postcode
                                                                                    })); // Update formData state
                                                                                },
                                                                                isDisabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 2,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "รหัสไปรษณีย์"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                className: "form-control ",
                                                                                placeholder: "กรอกรหัสไปรษณีย์",
                                                                                name: "bus_business_zipcodeid",
                                                                                value: values.bus_business_zipcodeid,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_zipcodeid: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center mb-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เบอร์โทรศัพท์"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_tel",
                                                                                placeholder: "กรอกเบอร์โทรศัพท์",
                                                                                value: values.bus_business_tel,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_tel: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เบอร์มือถือ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_phone",
                                                                                placeholder: "กรอกเบอร์มือถือ",
                                                                                value: values.bus_business_phone,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_phone: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "อีเมล"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "email",
                                                                                name: "bus_business_email",
                                                                                placeholder: "กรอกอีเมล",
                                                                                value: values.bus_business_email,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_email: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "d-flex align-items-center gap-3",
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "fs-20 fw-bold tc-5 my-4",
                                                                children: "ที่อยู่จัดส่งเอกสาร"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center mb-4",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 12,
                                                                    lg: 8,
                                                                    xl: 4,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ที่อยู่ธุรกิจ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_docaddress",
                                                                                placeholder: "กรอกที่อยู่",
                                                                                value: values.bus_business_docaddress,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_docaddress: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 2,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "จังหวัด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                name: "bus_business_docprovinceid",
                                                                                className: "w-100 select-st-1",
                                                                                placeholder: "เลือกจังหวัด",
                                                                                options: optionsProvice,
                                                                                value: optionsProvice.filter(function(item) {
                                                                                    return item.value === values.bus_business_docprovinceid;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    dispatch(getSupProvinceSup(e.value));
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_docprovinceid: e.value,
                                                                                        bus_business_docsubprovinceid: "",
                                                                                        bus_business_docdistrictid: ""
                                                                                    })); // Update formData state
                                                                                },
                                                                                isDisabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 2,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "อำเภอ/เขต"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                className: "w-100 select-st-1",
                                                                                placeholder: "เลือกอำเภอ/เขต",
                                                                                name: "bus_business_docsubprovinceid",
                                                                                options: optionsSupProvinceSup,
                                                                                value: optionsSupProvinceSup.filter(function(item) {
                                                                                    return item.value === values.bus_business_docsubprovinceid;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    dispatch(getDistrictSup(e.value));
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_docsubprovinceid: e.value,
                                                                                        bus_business_docdistrictid: 0
                                                                                    })); // Update formData state
                                                                                },
                                                                                isDisabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 2,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "แขวง/ตำบล"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                className: "w-100 select-st-1",
                                                                                placeholder: "เลือกแขวง/ตำบล",
                                                                                name: "bus_business_docdistrictid",
                                                                                options: optionsDistrictSup,
                                                                                value: optionsDistrictSup.filter(function(item) {
                                                                                    return item.value === values.bus_business_docdistrictid;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_docdistrictid: e.value,
                                                                                        bus_business_doczipcodeid: optionsDistrictSup.find(function(item) {
                                                                                            return item.value === e.value;
                                                                                        }).postcode
                                                                                    })); // Update formData state
                                                                                },
                                                                                isDisabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 2,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "รหัสไปรษณีย์"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                className: "form-control ",
                                                                                placeholder: "กรอกรหัสไปรษณีย์",
                                                                                name: "bus_business_doczipcodeid",
                                                                                value: values.bus_business_doczipcodeid,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_doczipcodeid: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center mb-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เบอร์โทรศัพท์"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_doctel",
                                                                                placeholder: "กรอกเบอร์โทรศัพท์",
                                                                                value: values.bus_business_doctel,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_doctel: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เบอร์มือถือ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_docphone",
                                                                                placeholder: "กรอกเบอร์มือถือ",
                                                                                value: values.bus_business_docphone,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_docphone: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 4,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "อีเมล"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "email",
                                                                                name: "bus_business_docemail",
                                                                                placeholder: "กรอกอีเมล",
                                                                                value: values.bus_business_docemail,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_docemail: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx(Row, {
                                                            className: "align-items-center mb-3",
                                                            children: /*#__PURE__*/ _jsx(Col, {
                                                                xs: 12,
                                                                md: 6,
                                                                lg: 4,
                                                                xl: 3,
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "วันที่สร้าง"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "bus_business_credate",
                                                                            placeholder: "-",
                                                                            value: moment(values.bus_business_credate).format("DD-MM-YYYY HH:mm:ss"),
                                                                            onChange: function(e) {
                                                                                handleChange(e); // Update Formik's state
                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                    bus_business_credate: e.target.value
                                                                                })); // Update formData state
                                                                            },
                                                                            readOnly: true,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                stepIndex == 2 && /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold tc-5 mb-2",
                                                            children: "ผู้ติดต่อหลัก"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center mb-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ชื่อ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_mainfname",
                                                                                placeholder: "กรอกชื่อ",
                                                                                value: values.bus_business_mainfname,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_mainfname: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "นามสกุล"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_mainlname",
                                                                                placeholder: "กรอกนามสกุล",
                                                                                value: values.bus_business_mainlname,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_mainlname: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ชื่อเล่น"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_mainnname",
                                                                                placeholder: "กรอกชื่อเล่น",
                                                                                value: values.bus_business_mainnname,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_mainnname: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "อีเมล"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_mainemail",
                                                                                placeholder: "กรอกอีเมล",
                                                                                value: values.bus_business_mainemail,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_mainemail: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เบอร์โทรศัพท์"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_maintel",
                                                                                placeholder: "กรอกเบอร์โทร",
                                                                                value: values.bus_business_maintel,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_maintel: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เบอร์มือถือ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_mainphone",
                                                                                placeholder: "กรอกเบอร์มือถือ",
                                                                                value: values.bus_business_mainphone,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_mainphone: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ตำแหน่ง"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_mainposition",
                                                                                placeholder: "กรอกตำแหน่ง",
                                                                                value: values.bus_business_mainposition,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_mainposition: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold tc-5 mb-2",
                                                            children: "ผู้ติดต่อสำรอง"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center mb-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ชื่อ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_subfname",
                                                                                placeholder: "กรอกชื่อ",
                                                                                value: values.bus_business_subfname,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_subfname: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "นามสกุล"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_sublname",
                                                                                placeholder: "กรอกนามสกุล",
                                                                                value: values.bus_business_sublname,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_sublname: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ชื่อเล่น"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_subnname",
                                                                                placeholder: "กรอกชื่อเล่น",
                                                                                value: values.bus_business_subnname,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_subnname: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "อีเมล"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_subemail",
                                                                                placeholder: "กรอกอีเมล",
                                                                                value: values.bus_business_subemail,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_subemail: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เบอร์โทรศัพท์"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_subtel",
                                                                                placeholder: "กรอกเบอร์โทร",
                                                                                value: values.bus_business_subtel,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_subtel: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เบอร์มือถือ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_subphone",
                                                                                placeholder: "กรอกเบอร์มือถือ",
                                                                                value: values.bus_business_subphone,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_subphone: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ตำแหน่ง"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_subposition",
                                                                                placeholder: "กรอกตำแหน่ง",
                                                                                value: values.bus_business_subposition,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_subposition: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                stepIndex == 3 && /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold tc-5 mb-2",
                                                            children: "ข้อมูล Social"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center mb-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "E-mail"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_soemail",
                                                                                placeholder: "กรอก E-mail",
                                                                                value: values.bus_business_soemail,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_soemail: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "Website"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_sowebsite",
                                                                                placeholder: "กรอก Website",
                                                                                value: values.bus_business_sowebsite,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_sowebsite: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "Facebook"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_sofb",
                                                                                placeholder: "กรอก Facebook",
                                                                                value: values.bus_business_sofb,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_sofb: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "Line Oa"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_solineoa",
                                                                                placeholder: "กรอก Line Oa",
                                                                                value: values.bus_business_solineoa,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_solineoa: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "IG"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_soig",
                                                                                placeholder: "กรอก IG",
                                                                                value: values.bus_business_soig,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_soig: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "TIKTOK"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_sotiktok",
                                                                                placeholder: "กรอก TIKTOK",
                                                                                value: values.bus_business_sotiktok,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_sotiktok: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "Shopee"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_soshopee",
                                                                                placeholder: "กรอก Shopee",
                                                                                value: values.bus_business_soshopee,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_soshopee: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 3,
                                                                    xl: 3,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "lazada"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_solazada",
                                                                                placeholder: "กรอก lazada",
                                                                                value: values.bus_business_solazada,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_solazada: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "URL Google Map"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "bus_business_urlmap",
                                                                                placeholder: "กรอก URL Google Map",
                                                                                value: values.bus_business_urlmap,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bus_business_urlmap: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                stepIndex == 4 && /*#__PURE__*/ _jsxs("div", {
                                                    className: "pt-3 px-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Stack, {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "fs-20 fw-bold tc-5 pt-2",
                                                                    children: "ข้อมูลธนาคารของคู่ค้า (สูงสุด 3 บัญชี)"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    className: "fs-18 btn-dg",
                                                                    disabled: bank.length == 3 ? true : false,
                                                                    onClick: function() {
                                                                        setDataBank({
                                                                            id: nanoid(),
                                                                            bus_bank_doctype: 1,
                                                                            bus_bank_accountno: "",
                                                                            bus_bank_name: "",
                                                                            bus_bank_bankid: 1,
                                                                            bus_bank_type: 1,
                                                                            bus_bank_branchn: "",
                                                                            bus_bank_file: "",
                                                                            bus_bank_remark: "",
                                                                            bus_bank_businessid: businessID
                                                                        });
                                                                        setModalBank(function(prev) {
                                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                                open: true,
                                                                                type: "create"
                                                                            });
                                                                        });
                                                                    },
                                                                    children: "+ เพิ่มธนาคาร"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("hr", {
                                                            className: "my-4",
                                                            style: {
                                                                opacity: 0.1
                                                            }
                                                        }),
                                                        bank.map(function(item, index) {
                                                            return /*#__PURE__*/ _jsxs("div", {
                                                                className: "px-3",
                                                                children: [
                                                                    index >= 1 && /*#__PURE__*/ _jsx("hr", {
                                                                        className: "my-4",
                                                                        style: {
                                                                            opacity: 0.1
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs(Stack, {
                                                                        direction: "row",
                                                                        justifyContent: "flex-end",
                                                                        children: [
                                                                            item.bus_bank_status == 1 && /*#__PURE__*/ _jsx("div", {
                                                                                className: "px-2 py-1 text-center",
                                                                                style: {
                                                                                    color: "#6D788D)",
                                                                                    backgroundColor: "rgba(244, 244, 244, 1)",
                                                                                    borderRadius: "20px",
                                                                                    width: "150px"
                                                                                },
                                                                                children: "แบบร่าง"
                                                                            }) || item.bus_bank_status == 2 && /*#__PURE__*/ _jsx("div", {
                                                                                className: "px-2 py-1 text-center",
                                                                                style: {
                                                                                    color: "#FDB428",
                                                                                    backgroundColor: "#FFF6E5",
                                                                                    borderRadius: "20px",
                                                                                    width: "150px"
                                                                                },
                                                                                children: "รออนุมัติ"
                                                                            }) || item.bus_bank_status == 3 && /*#__PURE__*/ _jsx("div", {
                                                                                className: "px-2 py-1 text-center",
                                                                                style: {
                                                                                    color: "#FFFFFF",
                                                                                    backgroundColor: "#10B02A",
                                                                                    borderRadius: "20px",
                                                                                    width: "150px"
                                                                                },
                                                                                children: "อนุมัติ"
                                                                            }) || item.bus_bank_status == 4 && /*#__PURE__*/ _jsx("div", {
                                                                                className: "px-2 py-1 text-center",
                                                                                style: {
                                                                                    color: "#F95057",
                                                                                    backgroundColor: "#FFE3E3",
                                                                                    borderRadius: "20px",
                                                                                    width: "150px"
                                                                                },
                                                                                children: "ไม่อนุมัติ"
                                                                            }) || item.bus_bank_status == 5 && /*#__PURE__*/ _jsx("div", {
                                                                                className: "px-2 py-1 text-center",
                                                                                style: {
                                                                                    color: "#FDB428",
                                                                                    backgroundColor: "#FFF6E5",
                                                                                    borderRadius: "20px",
                                                                                    width: "150px"
                                                                                },
                                                                                children: "รอแก้ไขข้อมูล"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(EditIcon, {
                                                                                style: {
                                                                                    color: "#797A7A",
                                                                                    fontSize: 40,
                                                                                    borderRadius: 40,
                                                                                    background: "#E9E9E9",
                                                                                    padding: 5,
                                                                                    marginLeft: 20
                                                                                },
                                                                                onClick: function() {
                                                                                    setDataBank(item);
                                                                                    setModalBank(function(prev) {
                                                                                        return _object_spread_props(_object_spread({}, prev), {
                                                                                            open: true,
                                                                                            data: item,
                                                                                            type: "update"
                                                                                        });
                                                                                    });
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(DeleteOutline, {
                                                                                style: {
                                                                                    color: "#FFF",
                                                                                    fontSize: 40,
                                                                                    borderRadius: 40,
                                                                                    background: "#dc3545",
                                                                                    padding: 5,
                                                                                    marginLeft: 20
                                                                                },
                                                                                onClick: function() {
                                                                                    return setModalDelBank(function(prev) {
                                                                                        return _object_spread_props(_object_spread({}, prev), {
                                                                                            open: true,
                                                                                            data: item,
                                                                                            type: "del"
                                                                                        });
                                                                                    });
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row gx-xl-3 pt-3 ",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-2 col-md-4",
                                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                                    className: "form-st-3",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "form-st-3 sm pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: "ธนาคาร"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                                as: "select",
                                                                                                name: "bus_bank_bankid",
                                                                                                className: "w-100 select-st-1",
                                                                                                options: optionsMstBank,
                                                                                                placeholder: "เลือกธนาคาร",
                                                                                                isDisabled: true,
                                                                                                value: optionsMstBank.filter(function(d) {
                                                                                                    return d.value == item.bus_bank_bankid;
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md-4",
                                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                                    className: "form-st-3",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "form-st-3 sm pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: "ประเภทบัญชี"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                                as: "select",
                                                                                                name: "bus_bank_type",
                                                                                                className: "w-100 select-st-1",
                                                                                                options: optionsMstBankAccountType,
                                                                                                placeholder: "เลือกประเภทบัญชี",
                                                                                                value: optionsMstBankAccountType.filter(function(d) {
                                                                                                    return d.value == item.bus_bank_type;
                                                                                                }),
                                                                                                isDisabled: true
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md-4",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "form-st-3",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "ชื่อบัญชี"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "bus_bank_name",
                                                                                            className: "form-control",
                                                                                            placeholder: "กรอกชื่อบัญชี",
                                                                                            value: item.bus_bank_name,
                                                                                            disabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md-4",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "form-st-3",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "เลขที่บัญชี"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "bus_bank_accountno",
                                                                                            className: "form-control",
                                                                                            placeholder: "กรอกเลขที่บัญชี",
                                                                                            value: item.bus_bank_accountno,
                                                                                            disabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md-4",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "form-st-3",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "ชื่อสาขา"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "bus_bank_branchn",
                                                                                            className: "form-control",
                                                                                            placeholder: "กรอกชื่อสาขา",
                                                                                            value: item.bus_bank_branchn,
                                                                                            disabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md-4",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "form-st-3",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "หมายเหตุ"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "bus_bank_remark",
                                                                                            className: "form-control",
                                                                                            placeholder: "กรอกหมายเหตุ",
                                                                                            value: item.bus_bank_remark,
                                                                                            disabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row gx-xl-4 align-items-center",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xxl-2 col-xl-3 col-md-4 ",
                                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                                    className: "form-st-3",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "form-st-3 sm pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: "เอกสาร"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                                as: "select",
                                                                                                name: "doc_type",
                                                                                                className: "w-100 select-st-1",
                                                                                                options: optionsDoc,
                                                                                                placeholder: "เลือกเอกสาร",
                                                                                                value: optionsDoc.filter(function(d) {
                                                                                                    return d.value == 1;
                                                                                                }),
                                                                                                isDisabled: true
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-auto",
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    style: {
                                                                                        width: "280px"
                                                                                    },
                                                                                    children: item.bus_bank_file != "" ? /*#__PURE__*/ _jsx(Link, {
                                                                                        to: item.bus_bank_file,
                                                                                        target: "_blank",
                                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                                            className: "docfile",
                                                                                            children: /*#__PURE__*/ _jsx("span", {
                                                                                                className: "icon pdf",
                                                                                                children: item.bus_bank_file ? item.bus_bank_file.substring(68) : ""
                                                                                            })
                                                                                        })
                                                                                    }) : /*#__PURE__*/ _jsx("button", {
                                                                                        type: "button",
                                                                                        className: "btn  btn-upload-file",
                                                                                        disabled: true,
                                                                                        children: "อัปโหลดไฟล์"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, index);
                                                        })
                                                    ]
                                                }),
                                                stepIndex == 5 && /*#__PURE__*/ _jsxs("div", {
                                                    className: "pt-3 px-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Stack, {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "fs-20 fw-bold tc-5 pt-2",
                                                                    children: "เอกสารแนบ"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    className: "fs-18 btn-dg",
                                                                    onClick: function() {
                                                                        setDataDoc({
                                                                            id: nanoid(),
                                                                            bus_doc_typeid: optionsMstDoc.filter(function(val) {
                                                                                return val.label == "อื่นๆ";
                                                                            })[0].value,
                                                                            bus_doc_typename: optionsMstDoc.filter(function(val) {
                                                                                return val.label == "อื่นๆ";
                                                                            })[0].label,
                                                                            bus_doc_name: null
                                                                        });
                                                                        setModalDoc(function(prev) {
                                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                                open: true,
                                                                                type: "create"
                                                                            });
                                                                        });
                                                                    },
                                                                    children: "+ เพิ่มเอกสารแนบอื่นๆ"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("hr", {
                                                            className: "my-4",
                                                            style: {
                                                                opacity: 0.1
                                                            }
                                                        }),
                                                        documents.map(function(item, index) {
                                                            return /*#__PURE__*/ _jsxs("div", {
                                                                className: "px-3",
                                                                children: [
                                                                    index >= 1 && /*#__PURE__*/ _jsx("hr", {
                                                                        className: "my-4",
                                                                        style: {
                                                                            opacity: 0.1
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row gx-xl-4 align-items-center",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xxl-4",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "เอกสาร"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            placeholder: "เลือกเอกสาร",
                                                                                            name: "bus_doc_typeid",
                                                                                            className: "w-100 select-st-1",
                                                                                            isDisabled: true,
                                                                                            options: optionsMstDoc,
                                                                                            value: optionsMstDoc.filter(function(d) {
                                                                                                return d.value == item.bus_doc_typeid;
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xxl-3",
                                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "flex-start",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Link, {
                                                                                            to: item.bus_doc_name,
                                                                                            target: "_blank",
                                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                                className: "docfile pt-2",
                                                                                                children: /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "icon pdf",
                                                                                                    children: item.bus_doc_name ? item.bus_doc_name.substring(68) : ""
                                                                                                })
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(EditIcon, {
                                                                                            style: {
                                                                                                color: "#797A7A",
                                                                                                fontSize: 40,
                                                                                                borderRadius: 40,
                                                                                                background: "#E9E9E9",
                                                                                                padding: 5,
                                                                                                marginLeft: 20
                                                                                            },
                                                                                            onClick: function() {
                                                                                                setModalDoc(function(prev) {
                                                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                                                        open: true,
                                                                                                        data: item,
                                                                                                        type: "update"
                                                                                                    });
                                                                                                });
                                                                                                setDataDoc(item);
                                                                                            }
                                                                                        }),
                                                                                        item.bus_doc_typename == "อื่นๆ" && /*#__PURE__*/ _jsx(DeleteOutline, {
                                                                                            style: {
                                                                                                color: "#FFF",
                                                                                                fontSize: 40,
                                                                                                borderRadius: 40,
                                                                                                background: "#dc3545",
                                                                                                padding: 5,
                                                                                                marginLeft: 20
                                                                                            },
                                                                                            onClick: function() {
                                                                                                return setModalDelDoc(function(prev) {
                                                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                                                        open: true,
                                                                                                        data: item,
                                                                                                        type: "del"
                                                                                                    });
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xxl-2",
                                                                                children: /*#__PURE__*/ _jsx(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "flex-start",
                                                                                    children: item.bus_doc_status == 1 && /*#__PURE__*/ _jsx("div", {
                                                                                        className: "px-2 py-1 text-center",
                                                                                        style: {
                                                                                            color: "#6D788D)",
                                                                                            backgroundColor: "rgba(244, 244, 244, 1)",
                                                                                            borderRadius: "20px",
                                                                                            width: "150px"
                                                                                        },
                                                                                        children: "แบบร่าง"
                                                                                    }) || item.bus_doc_status == 2 && /*#__PURE__*/ _jsx("div", {
                                                                                        className: "px-2 py-1 text-center",
                                                                                        style: {
                                                                                            color: "#FDB428",
                                                                                            backgroundColor: "#FFF6E5",
                                                                                            borderRadius: "20px",
                                                                                            width: "150px"
                                                                                        },
                                                                                        children: "รออนุมัติ"
                                                                                    }) || item.bus_doc_status == 3 && /*#__PURE__*/ _jsx("div", {
                                                                                        className: "px-2 py-1 text-center",
                                                                                        style: {
                                                                                            color: "#FFFFFF",
                                                                                            backgroundColor: "#10B02A",
                                                                                            borderRadius: "20px",
                                                                                            width: "150px"
                                                                                        },
                                                                                        children: "อนุมัติ"
                                                                                    }) || item.bus_doc_status == 4 && /*#__PURE__*/ _jsx("div", {
                                                                                        className: "px-2 py-1 text-center",
                                                                                        style: {
                                                                                            color: "#F95057",
                                                                                            backgroundColor: "#FFE3E3",
                                                                                            borderRadius: "20px",
                                                                                            width: "150px"
                                                                                        },
                                                                                        children: "ไม่อนุมัติ"
                                                                                    }) || item.bus_doc_status == 5 && /*#__PURE__*/ _jsx("div", {
                                                                                        className: "px-2 py-1 text-center",
                                                                                        style: {
                                                                                            color: "#FDB428",
                                                                                            backgroundColor: "#FFF6E5",
                                                                                            borderRadius: "20px",
                                                                                            width: "150px"
                                                                                        },
                                                                                        children: "รอแก้ไขข้อมูล"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            item.bus_doc_remark && /*#__PURE__*/ _jsxs("div", {
                                                                                className: "col-xxl-3",
                                                                                children: [
                                                                                    "หมายเหตุ : ",
                                                                                    item.bus_doc_remark
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, index);
                                                        })
                                                    ]
                                                }),
                                                stepIndex == 6 && /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 6,
                                                                    xl: 6,
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "fs-20 fw-bold tc-5 mb-2",
                                                                        children: [
                                                                            "ข้อมูลบัญชี",
                                                                            /*#__PURE__*/ _jsx(Button, {
                                                                                type: "button",
                                                                                onClick: function() {
                                                                                    setModalChangePassword(function(prev) {
                                                                                        return _object_spread_props(_object_spread({}, prev), {
                                                                                            open: true
                                                                                        });
                                                                                    });
                                                                                },
                                                                                className: "btn-primary ml-3",
                                                                                children: "รีเซ็ตรหัสผ่าน"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 6,
                                                                    xl: 6,
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex justify-content-end",
                                                                        children: [
                                                                            "สถานะ :",
                                                                            (formDataMember === null || formDataMember === void 0 ? void 0 : formDataMember.mb_mem_status) == 1 ? /*#__PURE__*/ _jsx("div", {
                                                                                className: "ml-2 px-2 py-1 text-center mb-1",
                                                                                style: {
                                                                                    color: "#FFFFFF",
                                                                                    backgroundColor: "#10B02A",
                                                                                    borderRadius: "20px",
                                                                                    width: "150px"
                                                                                },
                                                                                children: "เปิดใช้งาน"
                                                                            }) : /*#__PURE__*/ _jsx("div", {
                                                                                className: "ml-2 px-2 py-1 text-center",
                                                                                style: {
                                                                                    color: "#F95057",
                                                                                    backgroundColor: "#FFE3E3",
                                                                                    borderRadius: "20px",
                                                                                    width: "150px"
                                                                                },
                                                                                children: "ปิดใช้งาน"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Row, {
                                                            className: "align-items-center mb-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 6,
                                                                    xl: 6,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "อีเมลเข้าใช้งาน"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "mb_mem_email",
                                                                                placeholder: "อีเมลเข้าใช้งาน",
                                                                                value: formDataMember.mb_mem_email,
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    lg: 6,
                                                                    xl: 6,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "วันทีเปลี่ยนรหัสล่าสุด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "mb_mem_passdate",
                                                                                placeholder: "วันทีเปลี่ยนรหัสล่าสุด",
                                                                                value: formDataMember.mb_mem_passdate,
                                                                                readOnly: true,
                                                                                disabled: true,
                                                                                style: {
                                                                                    color: "red"
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Col, {
                                                                    xs: 12,
                                                                    md: 12,
                                                                    lg: 12,
                                                                    xl: 12,
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "TOKEN GOOGLE"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "mb_mem_tokengoogle",
                                                                                placeholder: "TOKEN GOOGLE",
                                                                                value: formDataMember.mb_mem_tokengoogle,
                                                                                readOnly: true,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    });
                                }
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx(Row, {
                    className: "align-items-center justify-content-center mb-3",
                    children: /*#__PURE__*/ _jsxs(Col, {
                        xs: 12,
                        md: 12,
                        lg: 6,
                        xl: 6,
                        className: "text-center justify-content-center ",
                        children: [
                            /*#__PURE__*/ _jsx(Image, {
                                src: "/images/profilebanner.png",
                                className: "mx-auto",
                                style: {
                                    height: "100%",
                                    maxHeight: "450px",
                                    width: "auto"
                                }
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-center fs-20 fw-500 tc-3",
                                children: "กรุณาลงทะเบียนคู่ค้าก่อนเข้าใช้งาน"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                onClick: function() {
                                    navigate("/info/create");
                                },
                                className: "btn-danger mt-3",
                                children: "เริ่มต้นลงทะเบียน"
                            })
                        ]
                    })
                })
            }),
            comment.length > 0 && /*#__PURE__*/ _jsx("div", {
                className: "card card-st-3 mb-3",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card-body px-10",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "",
                        children: comment.map(function(c, idx) {
                            var _c_SysUser, _c_MbMem;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "row gx-xl-2 mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-1 col-md-1 text-end",
                                        children: c.bus_comment_memid != null && c.bus_comment_memid != 0 ? /*#__PURE__*/ _jsx(Stack, {
                                            direction: "row",
                                            justifyContent: "flex-end",
                                            spacing: 3,
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/Avatar.png",
                                                roundedCircle: true,
                                                style: {
                                                    width: 50,
                                                    border: "4px solid #107BEF",
                                                    borderRadius: 30
                                                }
                                            })
                                        }) : c.comment_by === "Admin" ? null : /*#__PURE__*/ _jsx(_Fragment, {})
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-10 col-md-10",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-st-1 mx-3 p-3",
                                            style: (c.bus_comment_crebyid == null || c.bus_comment_crebyid == 0) && (c.bus_comment_memid == null || c.bus_comment_memid == 0) ? {
                                                background: "#F6E1E3"
                                            } : c.bus_comment_crebyid != null && c.bus_comment_crebyid != 0 ? {
                                                background: "#EFF2FC"
                                            } : {},
                                            children: [
                                                /*#__PURE__*/ _jsxs(Stack, {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    spacing: 3,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fw-400",
                                                            children: (c.bus_comment_crebyid == null || c.bus_comment_crebyid == 0) && (c.bus_comment_memid == null || c.bus_comment_memid == 0) ? /*#__PURE__*/ _jsx(_Fragment, {
                                                                children: "System"
                                                            }) : c.bus_comment_crebyid != null && c.bus_comment_crebyid != 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                children: [
                                                                    "Admin ",
                                                                    (_c_SysUser = c.SysUser) === null || _c_SysUser === void 0 ? void 0 : _c_SysUser.sys_user_nname
                                                                ]
                                                            }) : c.bus_comment_memid != null && c.bus_comment_memid != 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                children: [
                                                                    "Partner ",
                                                                    (_c_MbMem = c.MbMem) === null || _c_MbMem === void 0 ? void 0 : _c_MbMem.mb_mem_fullname
                                                                ]
                                                            }) : null
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: c.comment_by === "SYSTEM" ? "tc-10 fs-16" : "tc-12 fs-16",
                                                            children: moment(c.bus_comment_credate).locale("th").format("D MMMM y H:mm")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    children: c.bus_comment_dtail
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-1 col-md-1",
                                        children: (c.bus_comment_crebyid == null || c.bus_comment_crebyid == 0) && (c.bus_comment_memid == null || c.bus_comment_memid == 0) ? /*#__PURE__*/ _jsx(Avatar, {
                                            sx: {
                                                bgcolor: "error.main",
                                                fontSize: "26px"
                                            },
                                            children: "S"
                                        }) : c.bus_comment_crebyid != null && c.bus_comment_crebyid != 0 ? /*#__PURE__*/ _jsx(Image, {
                                            src: "/images/Avatar2.png",
                                            roundedCircle: true,
                                            style: {
                                                width: 50,
                                                border: "4px solid #107BEF",
                                                borderRadius: 30
                                            }
                                        }) : null
                                    })
                                ]
                            }, c.id);
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalChangePassword,
                setModal: setModalChangePassword,
                htitle: "รีเซ็ตรหัสผ่าน",
                hbtn: true,
                children: /*#__PURE__*/ _jsxs(Row, {
                    className: "align-items-center justify-items-center mt-3",
                    children: [
                        /*#__PURE__*/ _jsxs(Col, {
                            xs: 12,
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "รหัสผ่านเก่า"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "position-relative",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            type: inputtype,
                                            name: "passwordold",
                                            placeholder: "กรอกรหัสผ่านเก่า",
                                            value: formDataChangePassword.passwordold,
                                            onChange: function(e) {
                                                setFormDataChangePassword(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        passwordold: e.target.value
                                                    });
                                                }); // Update formData state
                                            },
                                            className: "form-st-1 mb-3"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            className: "btn btn-change-type-password",
                                            onClick: function() {
                                                return inputtype == "password" ? setInputtype("text") : setInputtype("password");
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Col, {
                            xs: 12,
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "รหัสผ่านใหม่"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "position-relative",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            type: inputtype,
                                            name: "password",
                                            placeholder: "กรอกรหัสผ่านใหม่",
                                            value: formDataChangePassword.password,
                                            onChange: function(e) {
                                                setFormDataChangePassword(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        password: e.target.value
                                                    });
                                                }); // Update formData state
                                            },
                                            className: "form-st-1 mb-3"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            className: "btn btn-change-type-password",
                                            onClick: function() {
                                                return inputtype == "password" ? setInputtype("text") : setInputtype("password");
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Col, {
                            xs: 12,
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "ยืนยันรหัสผ่านใหม่"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "position-relative",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            type: inputtype,
                                            name: "confrimpassword",
                                            placeholder: "กรอกยืนยันรหัสผ่านใหม่",
                                            value: formDataChangePassword.passconfrimpasswordword,
                                            onChange: function(e) {
                                                setFormDataChangePassword(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        confrimpassword: e.target.value
                                                    });
                                                }); // Update formData state
                                            },
                                            className: "form-st-1 mb-3"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            className: "btn btn-change-type-password",
                                            onClick: function() {
                                                return inputtype == "password" ? setInputtype("text") : setInputtype("password");
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Col, {
                            xs: 12,
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "outline-secondary",
                                    onClick: handleCloseChangePassword,
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "danger",
                                    onClick: handleClickChangePassword,
                                    className: "ml-3",
                                    children: "ยืนยัน"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDelBank,
                setModal: setModalDelBank,
                htitle: "ลบข้อมูลธนาคาร",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelBank, {
                    item: modalDelBank,
                    setModal: setModalDelBank,
                    memID: memID,
                    modalObj: modalObj,
                    setModalObj: setModalObj,
                    setIsLoading: setIsLoading,
                    setModalsuccess: setModalsuccess,
                    setModalerror: setModalerror
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalBank,
                setModal: setModalBank,
                htitle: "เพิ่มข้อมูลธนาคาร",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DataBank, {
                    optionsMstBank: optionsMstBank,
                    optionsMstBankAccountType: optionsMstBankAccountType,
                    optionsDoc: optionsDoc,
                    setBank: setBank,
                    setModalBank: setModalBank,
                    item: modalBank,
                    modalObj: modalObj,
                    bank: bank,
                    setModalObj: setModalObj,
                    setIsLoading: setIsLoading,
                    data: dataBank,
                    setData: setDataBank,
                    businessID: businessID,
                    memID: memID,
                    setModalsuccess: setModalsuccess,
                    setModalerror: setModalerror
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDoc,
                setModal: setModalDoc,
                htitle: "เพิ่มเอกสารแนบอื่นๆ",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DataDoc, {
                    optionsMstDoc: optionsMstDoc,
                    setDocuments: setDocuments,
                    setModal: setModalDoc,
                    item: modalDoc,
                    modalObj: modalObj,
                    documents: documents,
                    setModalObj: setModalObj,
                    setIsLoading: setIsLoading,
                    data: dataDoc,
                    setData: setDataDoc,
                    setModalsuccess: setModalsuccess,
                    setModalerror: setModalerror,
                    businessID: businessID,
                    memID: memID
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDelDoc,
                setModal: setModalDelDoc,
                htitle: "ลบข้อมูลธนาคาร",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelDoc, {
                    item: modalDelDoc,
                    setModal: setModalDelDoc,
                    memID: memID,
                    modalObj: modalObj,
                    setModalObj: setModalObj,
                    setIsLoading: setIsLoading,
                    setModalsuccess: setModalsuccess,
                    setModalerror: setModalerror
                })
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            }),
            /*#__PURE__*/ _jsx(ModalErrorCustom, {
                show: modalerror.visible,
                onHide: function() {
                    return setModalerror(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                texterror: modalerror.texterror,
                navigate: navigate,
                direction: modalerror.direction
            })
        ]
    });
}
var DataBank = function(_param) {
    var optionsMstBank = _param.optionsMstBank, optionsMstBankAccountType = _param.optionsMstBankAccountType, setBank = _param.setBank, optionsDoc = _param.optionsDoc, setModalBank = _param.setModalBank, item = _param.item, setModalObj = _param.setModalObj, modalObj = _param.modalObj, setIsLoading = _param.setIsLoading, bank = _param.bank, setData = _param.setData, data = _param.data, businessID = _param.businessID, setModalsuccess = _param.setModalsuccess, memID = _param.memID, setModalerror = _param.setModalerror, props = _object_without_properties(_param, [
        "optionsMstBank",
        "optionsMstBankAccountType",
        "setBank",
        "optionsDoc",
        "setModalBank",
        "item",
        "setModalObj",
        "modalObj",
        "setIsLoading",
        "bank",
        "setData",
        "data",
        "businessID",
        "setModalsuccess",
        "memID",
        "setModalerror"
    ]);
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), textImg = _useState[0], setTextImg = _useState[1];
    var handlePreviewFile = function(e) {
        if (e.target.files[0]) {
            console.log("e.target.files[0]", e.target.files[0]);
            var formData = new FormData();
            formData.append("upload_tmp_business", e.target.files[0]);
            dispatch(uploadInfo(formData, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setTextImg("bank");
        }
    };
    var uploadInfoReducer = useAppSelector(function(state) {
        return state.uploadInfoReducer;
    });
    var createBusinessBankReducer = useAppSelector(function(state) {
        return state.createBusinessBankReducer;
    });
    var updateBusinessBankReducer = useAppSelector(function(state) {
        return state.updateBusinessBankReducer;
    });
    useEffect(function() {
        if (textImg == "bank") {
            setIsLoading(uploadInfoReducer.isFetching);
            if (uploadInfoReducer.data) {
                console.log("uploadInfoReducer", uploadInfoReducer.data.data);
                console.log(data.id);
                setData(_object_spread_props(_object_spread({}, data), {
                    bus_bank_file: uploadInfoReducer.data.data
                }));
                setTextImg("");
            }
        }
    }, [
        uploadInfoReducer
    ]);
    var onBanking = function() {
        if (!item.data && item.type == "create") {
            var detail = {
                bus_bank_accountno: data.bus_bank_accountno,
                bus_bank_name: data.bus_bank_name,
                bus_bank_bankid: data.bus_bank_bankid,
                bus_bank_type: data.bus_bank_type,
                bus_bank_branchn: data.bus_bank_branchn,
                bus_bank_file: data.bus_bank_file ? data.bus_bank_file : "",
                bus_bank_remark: data.bus_bank_remark,
                bus_bank_businessid: businessID
            };
            if (data.bus_bank_name == "") {
                setModalerror(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        texterror: "กรุณากรอกชื่อบัญชี",
                        direction: ""
                    });
                });
            } else if (data.bus_bank_accountno == "") {
                setModalerror(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        texterror: "กรุณากรอกเลขบัญชี",
                        direction: ""
                    });
                });
            // } else if (data.bus_bank_file == null) {
            //   setModalerror((prev) => ({
            //     ...prev,
            //     visible: true,
            //     texterror: "กรุณาอัปโหลดไฟล์เอกสาร",
            //     direction: "",
            //   }));
            } else {
                dispatch(createBusinessBank(detail, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
                setModalBank(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        open: false
                    });
                });
            }
        } else {
            var detail1 = {
                bus_bank_id: data.bus_bank_id,
                bus_bank_accountno: data.bus_bank_accountno,
                bus_bank_name: data.bus_bank_name,
                bus_bank_bankid: data.bus_bank_bankid,
                bus_bank_type: data.bus_bank_type,
                bus_bank_branchn: data.bus_bank_branchn,
                bus_bank_file: data.bus_bank_file ? data.bus_bank_file : "",
                bus_bank_remark: data.bus_bank_remark,
                bus_bank_businessid: businessID
            };
            if (data.bus_bank_name == "") {
                setModalerror(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        texterror: "กรุณากรอกชื่อบัญชี",
                        direction: ""
                    });
                });
            } else if (data.bus_bank_accountno == "") {
                setModalerror(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        texterror: "กรุณากรอกเลขบัญชี",
                        direction: ""
                    });
                });
            // } else if (data.bus_bank_file == null) {
            //   setModalerror((prev) => ({
            //     ...prev,
            //     visible: true,
            //     texterror: "กรุณาอัปโหลดไฟล์เอกสาร",
            //     direction: "",
            //   }));
            } else {
                dispatch(updateBusinessBank(detail1, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
                setModalBank(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        open: false
                    });
                });
            }
        }
    };
    useEffect(function() {
        setIsLoading(createBusinessBankReducer.isFetching, updateBusinessBankReducer.isFetching);
        if (createBusinessBankReducer.data && !createBusinessBankReducer.isError) {
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "บันทึกข้อมูลธนาคารสำเร็จ",
                    direction: ""
                });
            });
            dispatch(getBusinessBank(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(clearcreateBusinessBank());
        }
        if (updateBusinessBankReducer.data && !updateBusinessBankReducer.isError) {
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "แก้ไขข้อมูลธนาคารสำเร็จ",
                    direction: ""
                });
            });
            dispatch(getBusinessBank(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(clearupdateBusinessBank());
        }
    }, [
        createBusinessBankReducer,
        updateBusinessBankReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "pt-3 px-3",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx(Form.Group, {
                            className: "form-st-3",
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "form-st-3 sm pb-1",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1",
                                        children: "ธนาคาร"
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "bus_bank_bankid",
                                        className: "w-100 select-st-1",
                                        options: optionsMstBank,
                                        placeholder: "เลือกธนาคาร",
                                        value: optionsMstBank.filter(function(d) {
                                            return d.value == data.bus_bank_bankid;
                                        }),
                                        onChange: function(e) {
                                            setData(_object_spread_props(_object_spread({}, data), {
                                                bus_bank_bankid: e.value
                                            })); // Update formData state
                                        }
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl col-md-4",
                        children: /*#__PURE__*/ _jsx(Form.Group, {
                            className: "form-st-3",
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "form-st-3 sm pb-1",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1",
                                        children: "ประเภทบัญชี"
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "bus_bank_type",
                                        className: "w-100 select-st-1",
                                        options: optionsMstBankAccountType,
                                        placeholder: "เลือกประเภทบัญชี",
                                        value: optionsMstBankAccountType.filter(function(d) {
                                            return d.value == data.bus_bank_type;
                                        }),
                                        onChange: function(e) {
                                            setData(_object_spread_props(_object_spread({}, data), {
                                                bus_bank_type: e.value
                                            })); // Update formData state
                                        }
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl col-md-4",
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "form-st-3",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "ชื่อบัญชี"
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    type: "text",
                                    name: "bus_bank_name",
                                    className: "form-control",
                                    placeholder: "กรอกชื่อบัญชี",
                                    value: data.bus_bank_name,
                                    onChange: function(e) {
                                        setData(_object_spread_props(_object_spread({}, data), {
                                            bus_bank_name: e.target.value
                                        })); // Update formData state
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl col-md-4",
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "form-st-3",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "เลขที่บัญชี"
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    type: "text",
                                    name: "bus_bank_accountno",
                                    className: "form-control",
                                    placeholder: "กรอกเลขที่บัญชี",
                                    value: data.bus_bank_accountno,
                                    onChange: function(e) {
                                        setData(_object_spread_props(_object_spread({}, data), {
                                            bus_bank_accountno: e.target.value
                                        })); // Update formData state
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl col-md-4",
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "form-st-3",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "ชื่อสาขา"
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    type: "text",
                                    name: "bus_bank_branchn",
                                    className: "form-control",
                                    placeholder: "กรอกชื่อสาขา",
                                    value: data.bus_bank_branchn,
                                    onChange: function(e) {
                                        setData(_object_spread_props(_object_spread({}, data), {
                                            bus_bank_branchn: e.target.value
                                        })); // Update formData state
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl col-md-4",
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "form-st-3",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "หมายเหตุ"
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    type: "text",
                                    name: "bus_bank_remark",
                                    className: "form-control",
                                    placeholder: "กรอกหมายเหตุ",
                                    value: data.bus_bank_remark,
                                    onChange: function(e) {
                                        setData(_object_spread_props(_object_spread({}, data), {
                                            bus_bank_remark: e.target.value
                                        })); // Update formData state
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4 align-items-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-xxl-2 col-xl-3 col-md-4 ",
                        children: [
                            /*#__PURE__*/ _jsx(Form.Group, {
                                className: "form-st-3",
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3 sm pb-1",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1",
                                            children: "เอกสาร"
                                        }),
                                        /*#__PURE__*/ _jsx(Select, {
                                            as: "select",
                                            name: "bus_bank_doctype",
                                            className: "w-100 select-st-1",
                                            options: optionsDoc,
                                            placeholder: "เลือกเอกสาร",
                                            value: optionsDoc.filter(function(d) {
                                                return d.value == data.bus_bank_doctype;
                                            }),
                                            onChange: function(e) {
                                                setData(_object_spread_props(_object_spread({}, data), {
                                                    bus_bank_doctype: e.value
                                                })); // Update formData state
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("input", {
                                type: "file",
                                name: "",
                                className: "fileUpload hide-input",
                                id: "fileUpload".concat(data.id),
                                accept: ".pdf",
                                onChange: function(e) {
                                    handlePreviewFile(e);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsx("div", {
                            style: {
                                width: "280px"
                            },
                            children: data.bus_bank_file == "" || data.bus_bank_file == null ? /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn  btn-upload-file",
                                onClick: function(e) {
                                    return document.getElementById("fileUpload".concat(data.id)).click();
                                },
                                children: "อัปโหลดไฟล์"
                            }) : /*#__PURE__*/ _jsx(Link, {
                                to: data.bus_bank_file,
                                target: "_blank",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "docfile",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "icon pdf",
                                        children: data.bus_bank_file ? data.bus_bank_file.substring(68) : ""
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: data.bus_bank_file && /*#__PURE__*/ _jsx(EditIcon, {
                            style: {
                                color: "#797A7A",
                                fontSize: 40,
                                borderRadius: 40,
                                background: "#E9E9E9",
                                padding: 5,
                                marginLeft: 20
                            },
                            onClick: function(e) {
                                return document.getElementById("fileUpload".concat(data.id)).click();
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-xl-3",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-xxl-12 col-xl-12 col-md-12 text-end",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            className: "btn-st-6 me-3 btn ms-auto",
                            onClick: function() {
                                setModalBank(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                                setData({});
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            className: "btn-dg",
                            onClick: function() {
                                onBanking();
                            },
                            children: "บันทึก"
                        })
                    ]
                })
            })
        ]
    });
};
var DelBank = function(_param) {
    var item = _param.item, setModal = _param.setModal, model = _param.model, setModalsuccess = _param.setModalsuccess, setModalerror = _param.setModalerror, setIsLoading = _param.setIsLoading, memID = _param.memID, modalObj = _param.modalObj, setModalObj = _param.setModalObj, props = _object_without_properties(_param, [
        "item",
        "setModal",
        "model",
        "setModalsuccess",
        "setModalerror",
        "setIsLoading",
        "memID",
        "modalObj",
        "setModalObj"
    ]);
    var _item_data;
    var dispatch = useAppDispatch();
    var deleteBusinessBankReducer = useAppSelector(function(state) {
        return state.deleteBusinessBankReducer;
    });
    var onDelBanking = function() {
        var id = {
            bus_bank_id: item.data.bus_bank_id
        };
        dispatch(deleteBusinessBank(id, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        setModal(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
    };
    useEffect(function() {
        setIsLoading(deleteBusinessBankReducer.isFetching);
        if (deleteBusinessBankReducer.data && !deleteBusinessBankReducer.isError) {
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "ลบข้อมูลธนาคารสำเร็จ",
                    direction: ""
                });
            });
            dispatch(getBusinessBank(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(cleardeleteBusinessBank());
        }
    }, [
        deleteBusinessBankReducer
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "pt-3 px-3",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-xl-3",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-xl-12",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-24 fw-bold tc-5 pt-2 text-center",
                            children: "คุณต้องการลบข้อมูลธนาคาร"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-20 tc-5 pt-4 text-center",
                            children: (_item_data = item.data) === null || _item_data === void 0 ? void 0 : _item_data.bus_bank_name
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-xxl-12 my-4 text-center",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            className: "btn-st-6 me-3 btn ms-auto",
                            onClick: function() {
                                setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            className: "btn-dg",
                            onClick: function() {
                                return onDelBanking();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
};
var DataDoc = function(_param) {
    var data = _param.data, item = _param.item, setModal = _param.setModal, setData = _param.setData, setModalObj = _param.setModalObj, modalObj = _param.modalObj, setIsLoading = _param.setIsLoading, documents = _param.documents, setDocuments = _param.setDocuments, optionsMstDoc = _param.optionsMstDoc, memID = _param.memID, setModalsuccess = _param.setModalsuccess, setModalerror = _param.setModalerror, businessID = _param.businessID, props = _object_without_properties(_param, [
        "data",
        "item",
        "setModal",
        "setData",
        "setModalObj",
        "modalObj",
        "setIsLoading",
        "documents",
        "setDocuments",
        "optionsMstDoc",
        "memID",
        "setModalsuccess",
        "setModalerror",
        "businessID"
    ]);
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), textImg = _useState[0], setTextImg = _useState[1];
    var handlePreviewFile = function(e) {
        if (e.target.files[0]) {
            console.log("e.target.files[0]", e.target.files[0]);
            var formData = new FormData();
            formData.append("upload_tmp_business", e.target.files[0]);
            dispatch(uploadInfo(formData, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setTextImg("doc");
        }
    };
    var uploadInfoReducer = useAppSelector(function(state) {
        return state.uploadInfoReducer;
    });
    var createBusinessDocReducer = useAppSelector(function(state) {
        return state.createBusinessDocReducer;
    });
    var updateBusinessDocReducer = useAppSelector(function(state) {
        return state.updateBusinessDocReducer;
    });
    useEffect(function() {
        if (textImg == "doc") {
            setIsLoading(uploadInfoReducer.isFetching);
            if (uploadInfoReducer.data) {
                console.log("uploadInfoReducer", uploadInfoReducer.data.data);
                setData(_object_spread_props(_object_spread({}, data), {
                    bus_doc_name: uploadInfoReducer.data.data
                }));
                setTextImg("");
            }
        }
    }, [
        uploadInfoReducer
    ]);
    var onDoc = function() {
        if (!item.data && item.type == "create") {
            var detail = {
                bus_doc_businessid: businessID,
                bus_doc_typeid: data.bus_doc_typeid,
                bus_doc_typename: data.bus_doc_typename,
                bus_doc_name: data.bus_doc_name
            };
            if (data.bus_doc_name == null) {
                setModalerror(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        texterror: "กรุณาอัปโหลดไฟล์เอกสาร",
                        direction: ""
                    });
                });
            } else {
                dispatch(createBusinessDoc(detail, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
                setModal(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        open: false
                    });
                });
            }
        } else {
            var detail1 = {
                bus_doc_businessid: businessID,
                bus_doc_typeid: data.bus_doc_typeid,
                bus_doc_typename: data.bus_doc_typename,
                bus_doc_name: data.bus_doc_name,
                bus_doc_id: data.bus_doc_id
            };
            if (data.bus_doc_name == null) {
                setModalerror(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        texterror: "กรุณาอัปโหลดไฟล์เอกสาร",
                        direction: ""
                    });
                });
            } else {
                dispatch(updateBusinessDoc(detail1, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
                setModal(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        open: false
                    });
                });
            }
        }
    };
    useEffect(function() {
        setIsLoading(createBusinessDocReducer.isFetching, updateBusinessDocReducer.isFetching);
        if (createBusinessDocReducer.data && !createBusinessDocReducer.isError) {
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "บันทึกข้อมูลเอกสารสำเร็จ",
                    direction: ""
                });
            });
            dispatch(getBusinessDoc(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(clearcreateBusinessDoc());
        }
        if (updateBusinessDocReducer.data && !updateBusinessDocReducer.isError) {
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "แก้ไขข้อมูลเอกสารสำเร็จ",
                    direction: ""
                });
            });
            dispatch(getBusinessDoc(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(clearupdateBusinessDoc());
        }
    }, [
        createBusinessDocReducer,
        updateBusinessDocReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "px-3",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4 align-items-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-xxl-5",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "mb-2 form-st-3 pb-1",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1",
                                        children: "เอกสาร"
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        placeholder: "เลือกเอกสาร",
                                        name: "bus_doc_typeid",
                                        onChange: function(e) {
                                            setData(_object_spread_props(_object_spread({}, data), {
                                                bus_doc_typeid: e.value
                                            })); // Update formData state
                                        },
                                        className: "w-100 select-st-1",
                                        options: !item.data ? optionsMstDoc.filter(function(val) {
                                            return val.label == "อื่นๆ";
                                        }) : optionsMstDoc,
                                        value: optionsMstDoc.filter(function(d) {
                                            return d.value == data.bus_doc_typeid;
                                        }),
                                        isDisabled: !item.data ? false : true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("input", {
                                type: "file",
                                name: "",
                                className: "fileUpload hide-input",
                                id: "fileUpload".concat(data.id),
                                accept: ".pdf",
                                onChange: function(e) {
                                    handlePreviewFile(e);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: data.bus_doc_name != null ? /*#__PURE__*/ _jsx(Link, {
                            to: data.bus_doc_name,
                            target: "_blank",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "docfile",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "icon pdf",
                                    children: data.bus_doc_name ? data.bus_doc_name.substring(68) : ""
                                })
                            })
                        }) : /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn  btn-upload-file",
                            onClick: function(e) {
                                return document.getElementById("fileUpload".concat(data.id)).click();
                            },
                            children: "อัปโหลดไฟล์"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: data.bus_doc_name && /*#__PURE__*/ _jsx(EditIcon, {
                            style: {
                                color: "#797A7A",
                                fontSize: 40,
                                borderRadius: 40,
                                background: "#E9E9E9",
                                padding: 5,
                                marginLeft: 20
                            },
                            onClick: function(e) {
                                return document.getElementById("fileUpload".concat(data.id)).click();
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-xl-3 mt-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-xxl-12 col-xl-12 col-md-12 text-end",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            className: "btn-st-6 me-3 btn ms-auto",
                            onClick: function() {
                                setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                                setData({});
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            className: "btn-dg",
                            onClick: function() {
                                return onDoc();
                            },
                            children: "บันทึก"
                        })
                    ]
                })
            })
        ]
    });
};
var DelDoc = function(_param) {
    var item = _param.item, setModal = _param.setModal, model = _param.model, setModalsuccess = _param.setModalsuccess, setModalerror = _param.setModalerror, setIsLoading = _param.setIsLoading, memID = _param.memID, modalObj = _param.modalObj, setModalObj = _param.setModalObj, props = _object_without_properties(_param, [
        "item",
        "setModal",
        "model",
        "setModalsuccess",
        "setModalerror",
        "setIsLoading",
        "memID",
        "modalObj",
        "setModalObj"
    ]);
    var _item_data;
    var dispatch = useAppDispatch();
    var deleteBusinessDocReducer = useAppSelector(function(state) {
        return state.deleteBusinessDocReducer;
    });
    var onDelDoc = function() {
        var id = {
            bus_doc_id: item.data.bus_doc_id
        };
        dispatch(deleteBusinessDoc(id, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        setModal(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
    };
    useEffect(function() {
        setIsLoading(deleteBusinessDocReducer.isFetching);
        if (deleteBusinessDocReducer.data && !deleteBusinessDocReducer.isError) {
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "ลบข้อมูลเอกสารสำเร็จ",
                    direction: ""
                });
            });
            dispatch(getBusinessDoc(memID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(cleardeleteBusinessDoc());
        }
    }, [
        deleteBusinessDocReducer
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "pt-3 px-3",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-xl-3",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-xl-12",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-24 fw-bold tc-5 pt-2 text-center",
                            children: "คุณต้องการลบข้อมูลเอกสาร"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-20 tc-5 pt-4 text-center",
                            children: (_item_data = item.data) === null || _item_data === void 0 ? void 0 : _item_data.bus_doc_typename
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-xxl-12 my-4 text-center",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            className: "btn-st-6 me-3 btn ms-auto",
                            onClick: function() {
                                setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            className: "btn-dg",
                            onClick: function() {
                                return onDelDoc();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
};
